export function Logo({ dark = false, small = false }) {
  const type = dark ? "text-bone" : "text-forest";
  const src = dark ? "/brand/mark_bone.png" : "/brand/mark_forest.png";
  const size = small ? 30 : 40;
  return (
    <div className="flex items-center gap-2.5" data-testid="hr-logo">
      <img
        src={src}
        alt="HomeRange"
        width={size}
        height={size}
        className="object-contain shrink-0"
        style={{ width: size, height: size }}
      />
      <span className={`flex flex-col leading-none ${type}`}>
        <strong className="font-serif tracking-[0.16em] text-[16px] font-bold">HOMERANGE</strong>
        <small className="hr-overline mt-1 text-[8px] text-saddle">Where Hunters Belong</small>
      </span>
    </div>
  );
}
